export const APP_LOAD = 'APP_LOAD';
export const REDIRECT = 'REDIRECT';
export const SETTINGS_SAVED = 'SETTINGS_SAVED';
export const REDIRECT_TO = 'REDIRECT_TO';

// CONFIG
export const CONFIG_GET_SPOKEN_LANGUAGES = 'CONFIG_GET_SPOKEN_LANGUAGES';
export const CONFIG_GET_SIGN_UP_PROPERTIES = 'CONFIG_GET_SIGN_UP_PROPERTIES';
export const CONFIG_SEND_FEEDBACK = 'CONFIG_SEND_FEEDBACK';

// Pages
export const SETTINGS_PAGE_UNLOADED = 'SETTINGS_PAGE_UNLOADED';
export const HOME_PAGE_LOADED = 'HOME_PAGE_LOADED';
export const HOME_PAGE_UNLOADED = 'HOME_PAGE_UNLOADED';
export const DASHBOARD_PAGE_UNLOADED = 'DASHBOARD_PAGE_UNLOADED';
export const DASHBOARD_PAGE_LOADED = 'DASHBOARD_PAGE_LOADED';
export const VIDEO_PAGE_LOADED = 'VIDEO_PAGE_LOADED';
export const VIDEO_PAGE_UNLOADED = 'VIDEO_PAGE_UNLOADED';
export const SET_PAGE = 'SET_PAGE';
export const CHANGE_TAB = 'CHANGE_TAB';
export const PROFILE_PAGE_LOADED = 'PROFILE_PAGE_LOADED';
export const PROFILE_PAGE_UNLOADED = 'PROFILE_PAGE_UNLOADED';

// Auth
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const LOGIN_PAGE_UNLOADED = 'LOGIN_PAGE_UNLOADED';
export const REGISTER_PAGE_UNLOADED = 'REGISTER_PAGE_UNLOADED';
export const UPDATE_FIELD_AUTH = 'UPDATE_FIELD_AUTH';
export const RECOVER_PASSWORD = 'RECOVER_PASSWORD';
export const GET_CURRENT_USER = 'GET_CURRENT_USER';
export const LOGIN_START = 'LOGIN_START';
export const SEND_EMAIL_VERIFICATION = 'SEND_EMAIL_VERIFICATION';
export const LOGIN_WITH_PROVIDER = 'LOGIN_WITH_PROVIDER';

// Async
export const ASYNC_START = 'ASYNC_START';
export const ASYNC_END = 'ASYNC_END';

// Video
export const JOIN_ROOM = 'JOIN_ROOM';

// MODAL
export const OPEN_MODAL = 'OPEN_MODAL';
export const CLOSE_MODAL = 'CLOSE_MODAL';

// SNACKBAR
export const OPEN_USER_SNACKBAR = 'OPEN_USER_SNACKBAR';
export const CLOSE_USER_SNACKBAR = 'CLOSE_USER_SNACKBAR';

// Verification
export const VERIFICATION_SEND = 'VERIFICATION_SEND';
export const VERIFICATION_VERIFY = 'VERIFICATION_VERIFY';

// Calls
export const CALL_CREATE = 'CALL_CREATE';
export const CALLS_GET = 'CALLS_GET';
export const CALLS_CONNECT_INTERPRETER = 'CALLS_CONNECT_INTERPRETER';
export const CALLS_FINISH = 'CALLS_FINISH';
export const CALLS_START = 'CALLS_START';
export const CALLS_PAUSE = 'CALLS_PAUSE';
export const CALLS_NEW_MATCH = 'CALLS_NEW_MATCH';
export const CALLS_DATA_RESET = 'CALLS_DATA_RESET';
export const INTERPRETER_SEARCH = 'INTERPRETER_SEARCH';
export const STOP_TIMER = "STOP_TIMER";
export const START_TIMER = "START_TIMER";
export const RESET_TIMER = "RESET_TIMER";

// Payment
export const DEAF_GET_CHARGE_TYPES = 'DEAF_GET_CHARGE_TYPES';
export const DEAF_BUY_MINUTES_CREDIT = 'DEAF_BUY_MINUTES_CREDIT';
export const INTERPRETERS_WITHDRAW = 'INTERPRETERS_WITHDRAW';
export const RESET_CREDIT = 'RESET_CREDIT';
export const DEAF_ADD_PAYMENT = 'DEAF_ADD_PAYMENT';
export const DEAF_GET_PAYMENT_IDS = 'DEAF_GET_PAYMENT_IDS';
export const DEAF_SELECT_PAYMENT_CARD = 'DEAF_SELECT_PAYMENT_CARD';
export const DEAF_REMOVE_PAYMENT = 'DEAF_REMOVE_PAYMENT';

// User
export const DEAF_GET_MINUTES_CREDIT = 'DEAF_GET_MINUTES_CREDIT';
export const INTERPRETER_GET_PAYOUT_CREDIT = 'INTERPRETER_GET_PAYOUT_CREDIT';
export const USER_EDIT = 'USER_EDIT';
export const DEAF_GET_CALL_HISTORY = 'DEAF_GET_CALL_HISTORY';
export const USERS_GET = 'USERS_GET';

// signup
export const SIGNUP_COMPLETED = 'SIGNUP_COMPLETED';
export const SIGNUP_PAGE_UNLOADED = 'SIGNUP_PAGE_UNLOADED';
export const SIGNUP_UPDATE_FIELD = 'SIGNUP_UPDATE_FIELD';
export const COMPLETE_DETAILS = 'COMPLETE_DETAILS';
export const COMPLETE_DETAILS_UNLOADED = 'COMPLETE_DETAILS_UNLOADED';
export const SIGNUP_START = 'SIGNUP_START';
export const USER_SIGN_UP = 'USER_SIGN_UP';

// SCHEDULE
export const SCHEDULE_CREATE = 'SCHEDULE_CREATE';
export const SCHEDULE_GET = 'SCHEDULE_GET';
export const SCHEDULE_GET_OR_CREATE_CALL = 'SCHEDULE_GET_OR_CREATE_CALL';
export const SCHEDULE_ACCEPT = 'SCHEDULE_ACCEPT';
export const SCHEDULE_REJECT = 'SCHEDULE_REJECT';
export const SCHEDULE_UPDATE = 'SCHEDULE_UPDATE';
export const SCHEDULE_LIST = 'SCHEDULE_LIST';
export const SCHEDULE_LIST_DEAF = 'SCHEDULE_LIST_DEAF';
export const SCHEDULE_LIST_INTERPERTER = 'SCHEDULE_LIST_INTERPERTER';

// Review
export const REVIEW_CREATE = 'REVIEW_CREATE';
export const REVIEWS_LIST = 'REVIEWS_LIST';

// Error
export const HANDLE_ERROR = 'HANDLE_ERROR';

// Mixpanel
export const MIXPANEL_EVENT = 'MIXPANEL_EVENT';



// WEBPACK FOOTER //
// ./src/constants/actionTypes.js